'use client';

import { apiRoutes, publicHttpClient } from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import type { VerifyOTPError } from './use-verify-otp-mutation';

export interface ResetPasscodeRequest {
  new_passcode: string;
}

export interface ResetPasscodeResponse {
  status: boolean;
}

export const resetPasscodeFn = async (body: ResetPasscodeRequest) => {
  const response = await publicHttpClient.put<ResetPasscodeResponse>(
    apiRoutes.auth.resetPasscode,
    {
      ...body,
    }
  );
  return response.data;
};

export const useResetPasscodeMutation = (
  opts?: UseMutationOptions<
    ResetPasscodeResponse,
    VerifyOTPError,
    ResetPasscodeRequest
  >
) =>
  useMutation<ResetPasscodeResponse, VerifyOTPError, ResetPasscodeRequest>({
    mutationFn: resetPasscodeFn,
    ...opts,
  });
